import React, { useContext, useState } from 'react'
import { SetupDataPageTemplate } from '../../../components/setup-pages/SetupDataPageTemplate'
import { pathRoot, schema, getOptionsElements } from '../Compensation';
import { setupData } from '../../../configs/routes';
import { Form } from "react-jsonschema-form-validation";
import { DiseaseGroupContext } from '../../../contexts/diseaseGroupContext';

export function Page1({ compensation, handleSave }) {

  const [haveReceived, setHaveReceived] = useState(compensation.haveReceived);

  const {theme} = useContext(DiseaseGroupContext);

  const options = [{
    label: "Yes",
    value: 0
  }, {
    label: "No",
    value: 1
  }, {
    label: "Not yet (ongoing)",
    value: 2
  }, {
    label: "Rather not say",
    value: 3
  }];

  const onNext = () => {
    return new Promise((resolve, reject) => {
      compensation.haveReceived = haveReceived;
      if (haveReceived === 3 || haveReceived === 1) {
        compensation.whereFrom = [];
        compensation.claimSuccess = null;
        compensation.lawFirm = "";
        compensation.employer = "";
        compensation.totalCompensation = "";

        if (haveReceived === 3) {
          compensation.whyNot = null;
          handleSave(compensation).then(resolve).catch(reject);
        }
        else {
          resolve();
        }

      }
      else {
        compensation.whyNot = null;

        resolve();
      }
    });
  }

  const nextTo = () => {
    switch (haveReceived) {
      case 0: return `${pathRoot}/3`;//yes
      case 1: return `${pathRoot}/2`;//no
      case 2: return `${pathRoot}/3`;//not yet
      case 3: return setupData; //rather not say
      default: return ""
    }
  }

  const headerDetails = {
    title: "Compensation",
    currentPage: 1,
    pageCount: 4
  };

  return (
    <SetupDataPageTemplate headerDetails={headerDetails} backTo={setupData} nextTextOverride={haveReceived === 3 ? "Finish" : null} onClickNext={{ async: true, func: onNext }} nextTo={nextTo()} hideNext={haveReceived === null}>
      <Form schema={schema}>
        <p className={"text-lg sm:text-xl font-bold mb-6"}>Have you received compensation for your mesothelioma?</p>
        <div>
          {getOptionsElements(options, "haveReceived", haveReceived, setHaveReceived, theme)}
        </div>
      </Form>
    </SetupDataPageTemplate>
  )
}
